<template>
  <div id="Tab1">
    <!-- Referral Information -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">
        Información del Referido
      </span>
    </div>

    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="table-referred">
      <table class="table table-borderless">
        <thead>
          <tr class="row">
            <th class="col-3 pb-0 ml-3">Número:</th>
            <th class="col-3 pb-0 pl-0">Estatus:</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-3 pt-0 ml-3">
              {{ setPeiAtInformation.referralNumber }}
            </td>
            <td class="col-3 pt-0 pl-0">
              {{
                setPeiAtInformation.completedFlag
                  ? "Completado"
                  : "No Completado"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- General Student Information -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">
        Información General del Estudiante
      </span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />

    <div class="table-referred pb-0">
      <table class="table table-borderless">
        <thead>
          <tr class="row">
            <th class="col-3 pb-0 ml-3">Nombre:</th>
            <th class="col-3 pb-0 mx-0 px-0">Número de SIE:</th>
            <th class="col-3 pb-0 mx-0 px-0">Fecha de Nacimiento:</th>
            <th class="col-2 pb-0 mr-0 pr-0 float-right">Edad:</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-3 pt-0 pb-0 ml-3">
              {{ setPeiAtInformation.fullName }}
            </td>
            <td class="col-3 pt-0 ml-0 px-0">
              {{ setPeiAtInformation.studentSieId }}
            </td>
            <td class="col-3 pt-0 ml-0 px-0">
              {{ setPeiAtInformation.studentBirthDateFormat }}
            </td>
            <td class="col-2 pt-0 mr-0 pr-0 float-right">
              {{ setPeiAtInformation.ageAmt }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-referred pt-0">
      <table class="table table-borderless">
        <thead>
          <tr class="row">
            <th class="col-3 pt-0 pb-0 ml-3">Género:</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-3 pt-0 ml-3">
              {{ setPeiAtInformation.genderDescription }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- School Information -->

    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">Información de Escuela</span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="table-referred pb-0">
      <table class="table table-borderless">
        <thead>
          <tr class="row">
            <th class="col-3 pb-0 ml-3">Región:</th>
            <th class="col-3 pb-0 mx-0 px-0">Distrito:</th>
            <th class="col-3 pb-0 mx-0 px-0">Municipio:</th>
            <th class="col-2 pb-0 mx-0 px-0">Escuela:</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-3 pt-0 pb-0 ml-3">
              {{ setPeiAtInformation.locationSchool.regionName }}
            </td>
            <td class="col-3 pt-0 ml-0 px-0">
              {{ setPeiAtInformation.locationSchool.municipalityName }}
            </td>
            <td class="col-3 pt-0 ml-0 px-0">
              {{ setPeiAtInformation.locationSchool.municipalityName }}
            </td>
            <td class="col-2 pt-0 ml-0 px-0">
              {{ setPeiAtInformation.locationSchool.locationSchoolCode }}&nbsp;
              {{ setPeiAtInformation.locationSchool.locationSchoolName }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-referred pt-0">
      <table class="table table-borderless">
        <thead>
          <tr class="row">
            <th class="col-3 pt-0 pb-0 ml-3">Grado:</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-3 pt-0 ml-3">
              {{ setPeiAtInformation.schoolGrade }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Student Contact Information -->
    <ValidationObserver ref="observer">
      <div class="tag-badge-info">
        <span class="tag-badge-title-info pb-2 pl-3">
          Información de Contacto Estudiante
        </span>
      </div>
      <div class="dropdown-divider mt-0 pb-2 ml-3" />

      <div class="table-referred pb-0">
        <table class="table table-borderless">
          <thead>
            <tr class="row">
              <th class="col-3 pb-0 ml-3">Nombre Encargado:</th>
              <th class="col-3 pb-0 mx-0 px-0">Teléfono Encargado:</th>
              <th class="col-3 pb-0 mx-0 px-0">Teléfono Adicional:</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td class="col-3 pt-0 pb-0 ml-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :custom-messages="{
                    required: 'El campo es obligatorio'
                  }"
                  rules="required"
                  name="personInChargeName"
                >
                  <CustomInput
                    ref="personInChargeName"
                    v-model="setPeiAtInformation.personInChargeName"
                    type="text"
                    class="control-input mt-3"
                    :disabled="atCompletedFlag"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
              <td class="col-3 pt-0 ml-0 px-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  :custom-messages="{
                    completePhone:
                      'Se deben completar los números telefónicos.',
                    required: 'El campo teléfono es obligatorio'
                  }"
                  name="teléfono1"
                  rules="required|completePhone"
                >
                  <CustomInput
                    v-model="setPeiAtInformation.personInChargePhone"
                    class="control-input mt-3"
                    :mask-type="'Phone'"
                    placeholder="(__) __-____"
                    :disabled="atCompletedFlag"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
              <td class="col-3 pt-0 ml-0 px-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  :custom-messages="{
                    completePhone: 'Se deben completar los números telefónicos.'
                  }"
                  name="teléfono2"
                  rules="completePhone"
                >
                  <CustomInput
                    v-model="setPeiAtInformation.personInChargeAdditionalPhone"
                    class="control-input mt-3"
                    :error="errors[0]"
                    :disabled="atCompletedFlag"
                    :mask-type="'Phone'"
                    placeholder="(__) __-____"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- School Contact Information -->
      <div class="tag-badge-info">
        <span class="tag-badge-title-info pb-2 pl-3">
          Información de Contacto Escuela
        </span>
      </div>
      <div class="dropdown-divider mt-0 pb-2 ml-3" />

      <div class="table-referred pb-0">
        <table class="table table-borderless">
          <thead>
            <tr class="row">
              <th class="col-3 pb-0 ml-3">Nombre Encargado:</th>
              <th class="col-3 pb-0 mx-0 px-0">Puesto:</th>
              <th class="col-3 pb-0 mx-0 px-0">Teléfono Escuela:</th>
              <th class="col-2 pb-0 mx-0 px-0">Teléfono Adicional:</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td class="col-3 pt-0 pb-0 ml-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :custom-messages="{
                    required: 'El campo es obligatorio'
                  }"
                  rules="required"
                  name="contactNameSchool"
                >
                  <CustomInput
                    v-model="setPeiAtInformation.contactName"
                    type="text"
                    class="control-input mt-3"
                    :disabled="atCompletedFlag"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
              <td class="col-3 pt-0 ml-0 px-0">
                <ValidationProvider
                  v-slot="{ errors, invalid }"
                  :custom-messages="{
                    required: 'El campo es obligatorio'
                  }"
                  rules="required"
                  name="peiCodePosition"
                >
                  <select
                    v-model="setPeiAtInformation.peiCodePosition"
                    class="control-input mt-3"
                    :disabled="atCompletedFlag"
                  >
                    <option
                      v-if="setPeiAtInformation.peiCodePosition == null"
                      :value="null"
                    >
                      Seleccione
                    </option>
                    <option
                      v-for="peiCode in setPeiAtCode"
                      :key="peiCode.id"
                      :value="peiCode.id"
                    >
                      {{ peiCode.spaShortDescription }}
                    </option>
                  </select>
                  <br />
                  <span v-if="invalid" class="invalid">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
              <td class="col-3 pt-0 ml-0 px-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  :custom-messages="{
                    completePhone:
                      'Se deben completar los números telefónicos.',
                    required: 'El campo teléfono es obligatorio'
                  }"
                  name="teléfono3"
                  rules="required|completePhone"
                >
                  <CustomInput
                    v-model="setPeiAtInformation.contactSchoolPhone"
                    class="control-input mt-3"
                    placeholder="(__) __-____"
                    :disabled="atCompletedFlag"
                    :mask-type="'Phone'"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
              <td class="col-2 pt-0 ml-0 px-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  immediate
                  :custom-messages="{
                    completePhone: 'Se deben completar los números telefónicos.'
                  }"
                  name="teléfono4"
                  rules="completePhone"
                >
                  <CustomInput
                    v-model="setPeiAtInformation.contactAdditionalPhone"
                    class="control-input mt-3"
                    :error="errors[0]"
                    :disabled="atCompletedFlag"
                    placeholder="(__) __-____"
                    :mask-type="'Phone'"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-referred pb-0">
        <table class="table table-borderless">
          <thead>
            <tr class="row">
              <th class="col-3 pb-0 ml-3" scope="col">Email:</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td class="col-3 pt-0 pb-0 ml-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="`${this.ValidationTriggered.validation ? '' : ''}`"
                  name="email"
                >
                  <CustomInput
                    ref="email"
                    v-model="setPeiAtInformation.email"
                    type="text"
                    class="control-input mt-3"
                    :disabled="atCompletedFlag"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomInput from "@/components/common/CustomInput";
import generalService from "@/services/pei/general";
import store from "@/store/index";
import alert from "@/mixin/alert.mixin";
import resourcesService from "@/services/resources.js";
import loading from "@/mixin/loading.mixin";
// import Tabs from '@/utils/constants/at/atTabs.js';
import atService from "@/modules/referral-at/api";
import { mapMutations } from "vuex";

export default {
  components: {
    CustomInput
  },
  mixins: [loading, alert],
  data() {
    return {
      setPeiAtInformation: {
        locationSchool: {}
      },
      setPeiAtCode: [],
      resources: [],
      selected: 0
    };
  },
  methods: {
    ...mapMutations(["setATSaveBtnDisable"]),
    getInformationPeiAt() {
      if (this.atServiceId != null && this.peiId != undefined) {
        atService
          .getGeneralInformation(this.atServiceId, this.peiId)
          .then(res => {
            if (res.data != null && res.data.id > 0) {
              this.setATSaveBtnDisable(false);
              this.setPeiAtInformation = res.data;
            }
          });
      }
    },
    generalPeiCodeAt() {
      generalService.generalPeiCodeAt().then(response => {
        this.setPeiAtCode = response.data;
      });
    },
    async save() {
      if (this.atServiceId === 0) {
        const createdAtServiceId = await atService.createAtService(this.peiId);

        if (createdAtServiceId > 0) {
          await store.dispatch("setSelectedAt", createdAtServiceId);
        }
      }

      const generalDTO = {
        PersonInChargeName: this.setPeiAtInformation.personInChargeName,
        PersonInChargePhone: this.setPeiAtInformation.personInChargePhone,
        PersonInChargeAdditionalPhone: this.setPeiAtInformation
          .personInChargeAdditionalPhone,
        ContactName: this.setPeiAtInformation.contactName,
        ContactSchoolPhone: this.setPeiAtInformation.contactSchoolPhone,
        ContactAdditionalPhone: this.setPeiAtInformation.contactAdditionalPhone,
        PositionId: this.setPeiAtInformation.peiCodePosition,
        Email: this.setPeiAtInformation.email,
        peiId: this.peiId,
        Id: this.atServiceId
      };

      this.$ApiPost("api/atservice/saveGeneral", generalDTO)
        .then(() => {
          this.ShowToast(
            this.resources["R03200110"],
            this.resources["R03200109"],
            "success"
          );
        })
        .catch(err => {
          this.response = err;
        });
    },
    customPhoneFormatter(number) {
      if (number != null) {
        return number.replace(/^([0-9]{3})([0-9]{3})([0-9]{4})$/, "($1) $2-$3");
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        "R90014",
        "R03200110",
        "R03200109"
      ]);
    }
  },
  async beforeMount() {},
  async mounted() {
    this.loadResources();
    this.generalPeiCodeAt();

    if (this.atServiceId == 0) {
      const createdAtServiceId = await atService.createAtService(
        store.getters.SelectedPei
      );

      if (createdAtServiceId > 0) {
        store.dispatch("setSelectedAt", createdAtServiceId);
      }
    }

    this.getInformationPeiAt();
    if (this.ValidationTriggered.validation) {
      await this.$refs.observer.validate();
    }
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    atServiceId() {
      return store.getters.SelectedAt;
    },
    peiId() {
      return store.getters.SelectedPei;
    },
    ValidationTriggered() {
      return store.getters.getatValidationTriggered;
    }
  },
  async activated() {
    this.setATSaveBtnDisable(true);
    this.loadResources();
    this.generalPeiCodeAt();
  }
};
</script>

<style scoped>
::placeholder {
  color: black !important;
}

tr.row > td:first-child {
  padding-left: 12px !important;
}

.invalid {
  color: #e85c5c;
}
</style>
